import Vue from "vue"
import Component from "vue-class-component"
import Guid from "@/scripts/guid"

@Component({})
export default class uniqueIdMixin extends Vue {
	uniqueId = ""

	created () {
		this.uniqueId = Guid.newGuid()
	}
}
